import { gql, useMutation, useQuery } from '@apollo/client'

export const PROMOTION_PREFERENCE = gql`
  query PromotionPreference($coachExternalId: ID!) {
    promotionPreference(coachExternalId: $coachExternalId) {
      coachExternalId
      enabled
    }
  }
`

export const SET_PROMOTION_PREFERENCE = gql`
  mutation SetPromotionPreference($coachExternalId: ID!, $enabled: Boolean!) {
    setPromotionPreference(
      coachExternalId: $coachExternalId
      enabled: $enabled
    ) {
      success
      code
      message
    }
  }
`

export const usePromotionPreference = coachExternalId => {
  const { data } = useQuery(PROMOTION_PREFERENCE, {
    variables: { coachExternalId },
    skip: !coachExternalId,
  })
  return { enabled: data?.promotionPreference?.enabled ?? null }
}

export const useSetPromotionPreference = coachExternalId => {
  const [mutate, { loading }] = useMutation(SET_PROMOTION_PREFERENCE)

  const setEnabled = async enabled => {
    const { data } = await mutate({
      variables: { coachExternalId, enabled },
      optimisticResponse: {
        setPromotionPreference: {
          __typename: 'GenericMutationResponse',
          success: true,
          code: '200',
          message: null,
        },
      },
      update: (cache, { data: result }) => {
        if (!result?.setPromotionPreference?.success) return
        cache.writeQuery({
          query: PROMOTION_PREFERENCE,
          variables: { coachExternalId },
          data: {
            promotionPreference: {
              __typename: 'PromotionPreference',
              coachExternalId,
              enabled,
            },
          },
        })
      },
    })
    if (!data?.setPromotionPreference?.success) {
      throw new Error(
        data?.setPromotionPreference?.message ||
          'Could not update promotion settings',
      )
    }
  }

  return { setEnabled, saving: loading }
}
